import React, { useContext, useEffect, useState } from 'react'
import { DContext } from '../../context/DataContext'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { FiArrowRight, FiTrash2 } from 'react-icons/fi'
import LoadingPage from './Loading'

function BucketList() {

  const { cart, setCart, filteredPackages, currency } = useContext(DContext)
  const [packages, setPackages] = useState(null)

  useEffect(() => {
    if (cart && filteredPackages) {
      let tempPackages = []
      cart.forEach(cartItem => {
        console.log("cartItem:", cartItem)
        const foundPackage = filteredPackages.find(item => item.id === cartItem.id)
        if (foundPackage)
          tempPackages.push(foundPackage)
      });

      setPackages(tempPackages)
    }
  }, [cart, filteredPackages])

  const { t } = useTranslation()
  const navPage = useNavigate()

  const handleNavigation = (path) => {
    navPage(`/package/${path}`)
  }

  const renderPrice = (pkg) => {
    if (pkg.priceType === "boat") {
      return pkg.speedBoatPrice[currency].adult || 0
    }
    else {
      return pkg.price[currency].adult || 0
    }
  }

  console.log("packages:", packages)

  if (!packages) {
    return <LoadingPage />
  }

  return (
    <div className='mx-auto my-4 w-[94%] max-w-5xl'>
      <h2 className='text-3xl font-black tracking-tight text-slate-900'>{t("bucketListPage.title")}</h2>
      <nav className='mt-2' aria-label='breadcrumb'>
        <ol className='flex flex-wrap items-center gap-2 text-sm text-slate-500'>
          <li><a href='/' className='font-medium text-slate-600 transition hover:text-[#1739bd]'>{t("sliderMenu.home")}</a></li>
          <li>/</li>
          <li className='font-semibold text-slate-700' aria-current='page'>{t("sliderMenu.bucketList")}</li>
        </ol>
      </nav>

      <div className='mt-4 space-y-3'>
        {packages.length > 0 ? packages.map((item, index) => (
          <div key={index} className='flex flex-wrap items-center justify-between gap-3 rounded-3xl border border-slate-200 bg-white p-4 shadow-sm'>
            <img className='h-[120px] w-[120px] rounded-2xl object-cover' src={item.img[0]} alt={item.name} role='button' onClick={() => handleNavigation(item.path)} />
            <div className='min-w-[200px] flex-1'>
              <h3 className='text-lg font-bold text-[#1739bd]' role='button' onClick={() => handleNavigation(item.path)}>{item.title}</h3>
              <p
                style={{
                  display: '-webkit-box',
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  WebkitLineClamp: 2
                }}
                role='button'
                className='mt-1 text-sm text-slate-600'
                onClick={() => handleNavigation(item.path)}
              >
                {item.desc}
              </p>
              <p className='mt-2 text-sm font-semibold text-slate-700'>{currency === 'usd' && '$'}{currency === 'thb' && '฿'} {renderPrice(item) || 0}</p>
            </div>
            <FiTrash2 className='text-3xl text-red-600' onClick={() => setCart(cart.filter((cartItem, i) => i !== index))} role='button' />
          </div>
        )) : <div className='rounded-2xl border border-dashed border-slate-300 bg-slate-50 p-6 text-center'>
          <h2 className='text-2xl font-bold text-slate-900'>{t("bucketListPage.empty")}</h2>
          <p className='mt-2 text-slate-600'>{t("bucketListPage.explore")} <a href='/packages' className='font-semibold text-[#1739bd]'>{t("bucketListPage.ourPackage")}</a> {t("bucketListPage.addMore")}</p>
        </div>}
      </div>

      {(cart && cart.length > 0) && <div className='my-4 text-center'>
        <p className='text-slate-700'>{t("bucketListPage.total")} {cart.length} {t("bucketListPage.packageSelected")}</p>
        <button className='sk-btn mt-3 rounded-full' onClick={() => navPage('/booking')}>{t("bucketListPage.proceed")} ! <FiArrowRight className='btn-arrow' /></button>
      </div>}
    </div>
  )
}

export default BucketList
